import {
  PROPERTIES_STATUS_FOR_ID,
  PropertyStatus
} from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyStatus = (
  data: IPropertyDetailsResponse
): PropertyStatus | null => {
  if (typeof data?.status_id === "undefined" || data?.status_id === null) {
    return null;
  }

  return PROPERTIES_STATUS_FOR_ID[data.status_id] as unknown as PropertyStatus;
};
